/**
 * Play limit utility - Tracks daily play limits using localStorage
 */

const STORAGE_KEY = 'parabul_play_history';

/**
 * Check if user can play today
 * @param {string} instagramUsername 
 * @returns {object} { canPlay: boolean, nextPlayTime: Date|null }
 */
export function canPlayToday(instagramUsername) {
    if (!instagramUsername) {
        return { canPlay: true, nextPlayTime: null };
    }

    const history = getPlayHistory();
    const today = new Date().toDateString();
    const userKey = instagramUsername.toLowerCase().replace('@', '');

    const lastPlayed = history[userKey];

    if (!lastPlayed) {
        return { canPlay: true, nextPlayTime: null };
    }

    const lastPlayedDate = new Date(lastPlayed).toDateString();

    if (lastPlayedDate === today) {
        // Already played today
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);

        return { canPlay: false, nextPlayTime: tomorrow };
    }

    return { canPlay: true, nextPlayTime: null };
}

/**
 * Record that user played today
 * @param {string} instagramUsername 
 */
export function recordPlay(instagramUsername) {
    if (!instagramUsername) return;

    const history = getPlayHistory();
    const userKey = instagramUsername.toLowerCase().replace('@', '');

    history[userKey] = new Date().toISOString();

    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
}

/**
 * Get play history from localStorage
 * @returns {object}
 */
function getPlayHistory() {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : {};
    } catch (error) {
        console.error('Error reading play history:', error);
        return {};
    }
}

/**
 * Clear old entries (older than 7 days)
 */
export function cleanupOldEntries() {
    const history = getPlayHistory();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    const cleaned = {};
    Object.entries(history).forEach(([user, date]) => {
        if (new Date(date) > sevenDaysAgo) {
            cleaned[user] = date;
        }
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(cleaned));
}
